module.exports = __webpack_public_path__ + "static/media/cmmedu.41824656.png";